import React from "react";

export default function DownloadsPage() {
  return (
    <div>
      <h2>Downloads</h2>
      <p>Forms and documents for residents.</p>
    </div>
  );
}